import script from "./GameLanding.vue?vue&type=script&setup=true&lang=js"
export * from "./GameLanding.vue?vue&type=script&setup=true&lang=js"

import "./GameLanding.vue?vue&type=style&index=0&id=dbafb020&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dbafb020"]])

export default __exports__